import { getSearchValue } from "SandboxViewerComponent/src/libs/URLUtils";
import layerStore from "@giscon/utils.layer-store";
import APIHelper from "@giscon/utils.api-helper-esri";

export function nop() { }
export function getURLParams() {
  let search = null;
  let showLayers = null;
  const searchLayerName = getSearchValue("searchLayerName");
  const searchLayerAttr = getSearchValue("searchLayerAttr");
  const searchValue = getSearchValue("searchValue");

  const doNotZoom = !!getSearchValue("doNotZoom");
  const optionalLayers = getSearchValue("optionalLayers");
  const transparencyOfLayers = getSearchValue("transparencyOfLayers");

  let hiddenOptionalLayers = getSearchValue("hiddenOptionalLayers");
  if (hiddenOptionalLayers) {
    hiddenOptionalLayers = hiddenOptionalLayers
      .split(",")
      .map((name) => name.trim());
  } else {
    hiddenOptionalLayers = null;
  }

  if (optionalLayers) {
    const layersArray = optionalLayers.split(",");
    if (layersArray.length) {
      const opacities = transparencyOfLayers && transparencyOfLayers.split(",");
      const considerOpacity =
        transparencyOfLayers && layersArray.length === opacities.length;
      showLayers = [];
      for (let i = 0; i < layersArray.length; i++) {
        const opacity =
          considerOpacity && opacities[i] >= 0 && opacities[i] <= 100
            ? parseInt(opacities[i], 10) / 100
            : 1;
        showLayers.push({ name: layersArray[i], opacity });
      }
    }
  }
  if (searchLayerName && searchLayerAttr && searchValue) {
    search = {
      layer: searchLayerName,
      attribute: searchLayerAttr,
      value: searchValue,
    };
  }
  return {
    // layerPermissions,
    search,
    showLayers,
    hiddenOptionalLayers,
    doNotZoom,
    // functions: selectedRole.functions,
  };
}

export function publishSelection(sendData) {
  // [{graphic, layer /* origin layer */}]
  const selection = layerStore.selectionManager
    .getSelection()
    .map((feature) => {
      const layer = layerStore.layerManager.getOriginLayer(feature);
      return {
        graphic: feature,
        layer,
        id: feature.internalEditorID,
        attributes: APIHelper.getAttributes(feature),
      };
    });
  sendData({
    action: "selectionChanged",
    data: selection,
  });
}

export function handleData(action, payload, sendData) {
  switch (action) {
    case "role-changed":
      return { role: payload };
    case "giscon-token":
      return { token: payload };
    case "get-selection":
      publishSelection(sendData);
      break;
    case "show-graphics-selector":
      return { graphicsSelectorOptions: payload };
    case "get-selection-mode": {
      sendData({
        action: "selectionModeChanged",
        active: layerStore.selectionManager.isSelectionActive(),
      });
      break;
    }

    case "deactivateSelection": {
      layerStore.selectionManager.deactivateSelection();
      sendData({
        action: "selectionModeChanged",
        active: layerStore.selectionManager.isSelectionActive(),
      });
      break;
    }

    case "activateSelection": {
      layerStore.selectionManager.activateSelection();
      sendData({
        action: "selectionModeChanged",
        active: layerStore.selectionManager.isSelectionActive(),
      });
      break;
    }

    case "restoreSelection": {
      layerStore.selectionManager.restoreSelection();
      sendData({
        action: "selectionModeChanged",
        active: layerStore.selectionManager.isSelectionActive(),
      });
      break;
    }
    default:
  }
  return null;
}
